<template>
  <div class="px-3">
    <span class="float-right">
      <b-link :href="`/aspect/new/?aspect_id=${type_id}`" class="btn btn-secondary">Add {{ title }}</b-link>
    </span>
    <h1>{{ title }}</h1>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Aspect</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="aspect in aspects" :key="aspect.value">
          <td>
            <b-link :href="`/aspect/${aspect.value}`">{{ aspect.text }}</b-link>
          </td>
          <td class="text-right">
            <b-link :href="`/aspect/${aspect.value}/edit`" class="m-2">Edit</b-link>
            <b-link :href="`/aspect/${aspect.value}`">View</b-link>
          </td>
        </tr>
        <tr v-if="aspects.length === 0">
          <td colspan="2" class="text-center text-muted">No aspects found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AspectDataService from '@/services/AspectDataService';

export default {
  name: "AspectList",
  data() {
    return {
      title: "General Agents",
      type_id: '37fd376e-eb47-4df8-bb0c-6f65d56502bf',
      aspects: []
    };
  },
  created() {
    if (this.$route.name === 'admin_insurance_company') {
      this.title = 'Insurance Companies';
      this.type_id = 'a87f5e62-4f0f-11e4-863c-449b3f674833';
    }

    AspectDataService.byType(this.type_id)
      .then((res) => {
        this.aspects = res.data;
      })
      .catch((error) => {
        console.error('Failed to load aspects:', error);
      });

    console.log(this.$route.name);
  }
};
</script>
